import { c as _c } from "react/compiler-runtime";
import { Badge } from "@website/ui/badge";
import { useTabButton } from "@website/ui/tab-button/tab-button.hook";
import styles from "@website/ui/tab-button/tab-button.module.scss";
import { TabButtonPropertiesType } from "@website/ui/tab-button/tab-button.types";
import { FC } from "react";
export const TabButton: FC<TabButtonPropertiesType> = properties => {
  const $ = _c(31);
  const {
    badge,
    description,
    disabled,
    Wrapper,
    Icon,
    title,
    selected,
    variant: t0,
    color: t1,
    iconPosition: t2,
    behavior: t3,
    size: t4,
    contentMinWidth: t5,
    defaultBorder: t6
  } = properties;
  const variant = t0 === undefined ? "contained" : t0;
  const color = t1 === undefined ? "primary" : t1;
  const iconPosition = t2 === undefined ? "top" : t2;
  const behavior = t3 === undefined ? "button" : t3;
  const size = t4 === undefined ? "content" : t4;
  const contentMinWidth = t5 === undefined ? true : t5;
  const defaultBorder = t6 === undefined ? false : t6;
  const {
    buttonProperties,
    linkProperties
  } = useTabButton(properties);
  const wrapperClassName = `${styles["tab-button"]} ${styles[variant]} ${styles[size]} ${iconPosition === "side" ? styles["side-icon"] : styles["top-icon"]} ${styles[color]} ${disabled ? styles.disabled : ""} ${selected ? styles.selected : ""} ${defaultBorder ? styles["border-default"] : ""} ${size === "content" && !contentMinWidth ? styles["without-content-min-width"] : ""}`;
  let t7;
  if ($[0] !== Icon) {
    t7 = Icon ? <div className={styles["button-icon"]}>{Icon}</div> : null;
    $[0] = Icon;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== title) {
    t8 = <div className={styles["button-title"]}>{title}</div>;
    $[2] = title;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== badge || $[5] !== color) {
    t9 = badge ? <Badge color={color} content={badge} /> : null;
    $[4] = badge;
    $[5] = color;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t8 || $[8] !== t9) {
    t10 = <div className={styles["button-middle"]}>{t8}{t9}</div>;
    $[7] = t8;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== description) {
    t11 = description ? <div className={styles["button-description"]}>{description}</div> : null;
    $[10] = description;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10 || $[13] !== t11) {
    t12 = <div className={styles["button-content"]}>{t10}{t11}</div>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12 || $[16] !== t7) {
    t13 = <>{t7}{t12}</>;
    $[15] = t12;
    $[16] = t7;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const content = t13;
  if (behavior === "link") {
    let t14;
    if ($[18] !== content || $[19] !== linkProperties || $[20] !== wrapperClassName) {
      t14 = <a {...linkProperties} className={wrapperClassName}>{content}</a>;
      $[18] = content;
      $[19] = linkProperties;
      $[20] = wrapperClassName;
      $[21] = t14;
    } else {
      t14 = $[21];
    }
    return t14;
  }
  if (behavior === "custom" && Wrapper) {
    let t14;
    if ($[22] !== Wrapper || $[23] !== content || $[24] !== linkProperties || $[25] !== wrapperClassName) {
      t14 = <Wrapper {...linkProperties} className={wrapperClassName}>{content}</Wrapper>;
      $[22] = Wrapper;
      $[23] = content;
      $[24] = linkProperties;
      $[25] = wrapperClassName;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    return t14;
  }
  let t14;
  if ($[27] !== buttonProperties || $[28] !== content || $[29] !== wrapperClassName) {
    t14 = <button {...buttonProperties} className={wrapperClassName}>{content}</button>;
    $[27] = buttonProperties;
    $[28] = content;
    $[29] = wrapperClassName;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};